// extracted by mini-css-extract-plugin
export default {"containerImage":"Picture_containerImage__QVaFf","image":"Picture_image__FFEcS","containerNumberText":"Picture_containerNumberText__rv4Y4"};